import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  OnInit,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { PwaInstallService } from '../../services/pwa-install.service';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'finance-pwa-install-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './install-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InstallButtonComponent implements OnInit {
  dismissed = false;
  readonly appName = environment.appName;
  readonly appShortName = environment.appShortName;
  private readonly STORAGE_KEY = 'finance-pwa-install-dismissed';
  private readonly DISMISS_COOLDOWN_DAYS = 7;

  constructor(public svc: PwaInstallService) {}

  ngOnInit() {
    const raw = localStorage.getItem(this.STORAGE_KEY);
    if (!raw) return;
    try {
      const { dismissedAt } = JSON.parse(raw);
      const days =
        (Date.now() - new Date(dismissedAt).getTime()) / (1000 * 60 * 60 * 24);
      this.dismissed = days < this.DISMISS_COOLDOWN_DAYS;
    } catch {
      this.dismissed = raw === 'true';
    }
  }

  async install() {
    const result = await this.svc.promptInstall(); // 'accepted' | 'dismissed' | 'unavailable'
    if (result === 'accepted') this.dismissed = true;
  }

  dismiss() {
    this.dismissed = true;
    localStorage.setItem(
      this.STORAGE_KEY,
      JSON.stringify({ dismissedAt: new Date().toISOString() })
    );
  }

  @HostListener('document:keydown.escape')
  onEsc() {
    if (!this.dismissed) this.dismiss();
  }
}
